import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { AppDownloadBanner } from '@gumtree/ui-library';
import ErrorBoundary from '../error-boundary';
import NavBar from './nav-bar/nav-bar';
import CategoryNavRibbon from '../category-nav-ribbon/category-nav-ribbon';
import SimpleHeader from './simple-header/simple-header';
import SimpleHeaderOnSyi from './simple-header/simple-header-syi';
import type { ShellState } from '../reducers/common';

const Header = () => {
    const { showSimpleHeaderOnly, showOnMobile, showOnSyiPostFlow } = useSelector(
        (state: ShellState) => ({
            showSimpleHeaderOnly: state.simpleHeader?.showOnly,
            showOnMobile: state.baseConfig.device.type === 'mobile',
            showOnSyiPostFlow: ['PostAd', 'EditAd'].includes(state.baseConfig.pageType),
        })
    );

    const getHeaderContent = () => {
        let headerContent: React.ReactNode;
        if (showSimpleHeaderOnly) {
            headerContent = <SimpleHeader />;
        } else if (showOnMobile && showOnSyiPostFlow) {
            headerContent = <SimpleHeaderOnSyi />;
        } else {
            headerContent = (
                <>
                    <NavBar />
                    <CategoryNavRibbon />
                </>
            );
        }
        return headerContent;
    };

    return (
        <Fragment>
            <ErrorBoundary>
                <AppDownloadBanner />
                <header className="header">{getHeaderContent()}</header>
            </ErrorBoundary>
        </Fragment>
    );
};

export default Header;
